/* eslint-disable @typescript-eslint/default-param-last */
import { Reducer } from 'redux';
import { IApiList, ILedgerEntry } from 'types';
import { Ledger } from './types';

const initialState: IApiList<ILedgerEntry> | null = null;

export const ledgerReducer: Reducer<IApiList<ILedgerEntry> | null> = (state = initialState, action) => {
  switch (action.type) {
    case Ledger.GET_PREFUND_LEDGER_SUCCESS: {
      return action.payload;
    }
    default: {
      return state;
    }
  }
};
